import { LinkContainer } from 'react-router-bootstrap';
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import logo from '../Assets/img/logo.png';
import Connect from './Connect';
import { getWeb3 } from '../helper/connectors';
import bscstakeAbi from '../json/bscstake.json';
import { DEFAULT_CHAIN, contract } from '../helper/constant';
import { Link } from 'react-router-dom';
import { useAccount } from 'wagmi';


const Header = () => {
    const [sticky, setSticky] = useState("");
    const [owner, setOwner] = useState("")
    const { address } = useAccount();

    useEffect(() => {
        window.addEventListener("scroll", isSticky);
        return () => {
            window.removeEventListener("scroll", isSticky);
        };
    }, []);

    const isSticky = () => {
        const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 150 ? "is-sticky" : "";
        setSticky(stickyClass);
    }
    const classes = `header-section ${sticky}`;

    useEffect(() => {
        async function fetch(){
            let web3 = getWeb3();
            let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);
            let owner = await stakeContract.methods.owner().call();
            setOwner(owner);
        }
        if (address) {
            fetch();
        }
        else{
            setOwner('')
        }
    }, [address])

    return (
        <>
            <Navbar className={`${classes} main-header navbar-dark`} expand="lg">
                <Container>
                    <LinkContainer to="/">
                        <Navbar.Brand>
                            <img src={logo} alt="Credit Logo" />
                        </Navbar.Brand>
                    </LinkContainer>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="align-items-lg-center ms-auto">
                            <Nav.Link className="text-white" href="https://futurecoines.com/privacv-policy/" target="_blank">Privacy policy</Nav.Link>
                            <Nav.Link className="text-white" href="https://coinmarketcap.com/dexscan/bsc/0x7fd216c40c84497c9f79bb4eaf7c0dab0a58c265/" target="_blank">Coinmarketcap</Nav.Link>
                            <Nav.Link className="text-white" href="https://www.dextools.io/app/en/bnb/pair-explorer/0x7fd216c40c84497c9f79bb4eaf7c0dab0a58c265" target="_blank">Dextools</Nav.Link>
                            {address && address.toLowerCase() === owner.toLowerCase() &&
                                <Nav.Link className='text-white'><Link to="/admin" className='text-white'>Admin</Link></Nav.Link>
                            }
                            <Connect /> 
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default Header